export const groupBy = (array: any[], key: string) => {
  return array.reduce((arr: any[], item: any) => {
    (arr[item[key]] = arr[item[key]] || []).push(item);
    return arr;
  }, {});
};
